import { useState, useRef } from "react";

const T = {
  bg:"#0B0F1A", surface:"#111827", card:"#1A2235", border:"#1E2D45",
  accent:"#38BDF8", green:"#34D399", yellow:"#FCD34D", red:"#F87171",
  purple:"#A78BFA", orange:"#FB923C", pink:"#F472B6",
  textPri:"#F0F6FF", textSec:"#94A3B8", textMute:"#4B5563",
  codeBg:"#060D18",
};

const SUBJECTS = [
  {
    id: "maths",
    label: "Mathematics",
    icon: "➗",
    color: T.accent,
    tagline: "NCERT Class 9 — Numbers to Probability",
    chapters: [
      { no:1,  title:"Number Systems",                        topics:["Irrational numbers","Real numbers on number line","Laws of exponents"] },
      { no:2,  title:"Polynomials",                           topics:["Degree of a polynomial","Remainder theorem","Factor theorem","Algebraic identities"] },
      { no:3,  title:"Coordinate Geometry",                   topics:["Cartesian plane","Plotting points","Quadrants"] },
      { no:4,  title:"Linear Equations in Two Variables",     topics:["ax + by + c = 0","Infinite solutions","Graph of a linear equation"] },
      { no:5,  title:"Introduction to Euclid's Geometry",    topics:["Euclid's definitions","Axioms and postulates","Equivalent versions of 5th postulate"] },
      { no:6,  title:"Lines and Angles",                      topics:["Pairs of angles","Parallel lines","Transversal","Angle sum property"] },
      { no:7,  title:"Triangles",                             topics:["Congruence rules (SAS, ASA, SSS, RHS)","Properties of isosceles triangle"] },
      { no:8,  title:"Quadrilaterals",                        topics:["Angle sum property","Parallelogram properties","Mid-point theorem"] },
      { no:9,  title:"Areas of Parallelograms & Triangles",  topics:["Figures on same base","Area theorems"] },
      { no:10, title:"Circles",                               topics:["Equal chords","Angle subtended by arc","Cyclic quadrilaterals"] },
      { no:11, title:"Constructions",                         topics:["Bisecting angles","Triangle constructions"] },
      { no:12, title:"Heron's Formula",                       topics:["Area when all sides known","Applications to quadrilaterals"] },
      { no:13, title:"Surface Areas and Volumes",             topics:["Cuboid, Cylinder, Cone, Sphere","Combining solids"] },
      { no:14, title:"Statistics",                            topics:["Mean, Median, Mode","Bar graphs, Histograms, Frequency polygons"] },
      { no:15, title:"Probability",                           topics:["Experimental probability","Events, outcomes, frequency"] },
    ],
  },
  {
    id: "science",
    label: "Science",
    icon: "🔬",
    color: T.green,
    tagline: "NCERT Class 9 — Physics, Chemistry & Biology",
    chapters: [
      { no:1,  title:"Matter in Our Surroundings",            topics:["States of matter","Evaporation","Boiling & melting"] },
      { no:2,  title:"Is Matter Around Us Pure?",             topics:["Mixtures, solutions","Colloids","Separation techniques"] },
      { no:3,  title:"Atoms and Molecules",                   topics:["Laws of chemical combination","Atomic mass","Mole concept"] },
      { no:4,  title:"Structure of the Atom",                 topics:["Electrons, protons, neutrons","Bohr's model","Valency, isotopes"] },
      { no:5,  title:"The Fundamental Unit of Life",          topics:["Cell theory","Prokaryote vs eukaryote","Cell organelles"] },
      { no:6,  title:"Tissues",                               topics:["Plant tissues","Animal tissues","Epithelial, connective, muscular, neural"] },
      { no:7,  title:"Diversity in Living Organisms",         topics:["Hierarchy of classification","Five kingdoms","Nomenclature"] },
      { no:8,  title:"Motion",                                topics:["Distance vs displacement","Speed, velocity, acceleration","Equations of motion","Graphs"] },
      { no:9,  title:"Force and Laws of Motion",              topics:["Newton's three laws","Inertia","Momentum conservation"] },
      { no:10, title:"Gravitation",                           topics:["Universal law","Free fall","Weight vs mass","Buoyancy, Archimedes"] },
      { no:11, title:"Work and Energy",                       topics:["Work done by a force","Kinetic & potential energy","Law of conservation"] },
      { no:12, title:"Sound",                                 topics:["Wave nature","Speed of sound","Reflection, echo","SONAR, human ear"] },
      { no:13, title:"Why Do We Fall Ill?",                   topics:["Health vs disease","Infectious diseases","Vaccines, antibiotics"] },
      { no:14, title:"Natural Resources",                     topics:["Air, water, soil","Biogeochemical cycles","Ozone layer"] },
      { no:15, title:"Improvement in Food Resources",         topics:["Crop improvement","Animal husbandry","Fishing, bee-keeping"] },
    ],
  },
  {
    id: "sst",
    label: "Social Science",
    icon: "🌍",
    color: T.orange,
    tagline: "NCERT Class 9 — History · Geography · Civics · Economics",
    chapters: [
      { no:"H1", title:"The French Revolution",                      topics:["Causes of revolution","Declaration of Rights","Reign of Terror","Napoleon"] },
      { no:"H2", title:"Socialism in Europe & Russian Revolution",   topics:["Capitalism vs socialism","February & October revolution","Stalin's collectivisation"] },
      { no:"H3", title:"Nazism and the Rise of Hitler",              topics:["Weimar Republic","Nazi ideology","Holocaust","Youth in Nazi Germany"] },
      { no:"H4", title:"Forest Society and Colonialism",             topics:["Scientific forestry","Resistance in Bastar","Java — Dutch colonialism"] },
      { no:"H5", title:"Pastoralists in the Modern World",           topics:["Nomads of India","Colonial impact","Maasai of Africa"] },
      { no:"G1", title:"India — Size and Location",                  topics:["Latitudinal & longitudinal extent","India and neighbours","Time zones"] },
      { no:"G2", title:"Physical Features of India",                 topics:["Himalayan ranges","Northern plains","Peninsular plateau","Islands"] },
      { no:"G3", title:"Drainage",                                   topics:["Himalayan & Peninsular rivers","Lakes","River pollution"] },
      { no:"G4", title:"Climate",                                    topics:["Monsoon mechanism","Seasons","El Niño effect"] },
      { no:"G5", title:"Natural Vegetation and Wildlife",            topics:["Types of forests","Wildlife","Biosphere reserves"] },
      { no:"G6", title:"Population",                                 topics:["Census, growth rate","Age-sex composition","Literacy, occupational structure"] },
      { no:"C1", title:"What is Democracy? Why Democracy?",          topics:["Features of democracy","Arguments for and against","Merits & demerits"] },
      { no:"C2", title:"Constitutional Design",                      topics:["South Africa, India","Constituent Assembly","Key features of Indian Constitution"] },
      { no:"C3", title:"Electoral Politics",                         topics:["Why elections?","Election Commission","Code of conduct"] },
      { no:"C4", title:"Working of Institutions",                    topics:["Parliament","Prime Minister & Cabinet","Supreme Court","Civil servants"] },
      { no:"C5", title:"Democratic Rights",                          topics:["Fundamental Rights","Rights in practice","Expanding democracy"] },
      { no:"E1", title:"Story of Village Palampur",                  topics:["Farming in Palampur","Capital and labour","Non-farm activities"] },
      { no:"E2", title:"People as Resource",                         topics:["Human capital","Unemployment types","Role of education & health"] },
      { no:"E3", title:"Poverty as a Challenge",                     topics:["Poverty line","Causes","Anti-poverty measures","MNREGA"] },
      { no:"E4", title:"Food Security in India",                     topics:["Buffer stock","PDS","Green Revolution","Challenges"] },
    ],
  },
  {
    id: "hindi",
    label: "Hindi",
    icon: "🔤",
    color: T.purple,
    tagline: "NCERT Class 9 — Kshitij & Kritika",
    chapters: [
      { no:"K1",  title:"दो बैलों की कथा — मुंशी प्रेमचंद",      topics:["गद्य — कहानी","बैलों के माध्यम से स्वतंत्रता का सन्देश","भाव और भाषा"] },
      { no:"K2",  title:"ल्हासा की ओर — राहुल सांकृत्यायन",        topics:["गद्य — यात्रा-वृत्तांत","तिब्बत यात्रा","विविधता और एकता"] },
      { no:"K3",  title:"उपभोक्तावाद की संस्कृति — श्यामाचरण दुबे", topics:["गद्य — निबन्ध","उपभोक्तावाद के दुष्प्रभाव"] },
      { no:"K4",  title:"साँवले सपनों की याद — जाबिर हुसैन",        topics:["गद्य — संस्मरण","सालिम अली की याद"] },
      { no:"K5",  title:"नाना साहब की पुत्री — चपला देवी",          topics:["गद्य — कहानी","1857 की क्रांति","देशभक्ति"] },
      { no:"K6",  title:"प्रेमचंद के फटे जूते — हरिशंकर परसाई",     topics:["गद्य — व्यंग्य","व्यंग्य शैली","सत्य और आदर्श"] },
      { no:"K7",  title:"मेरे बचपन के दिन — महादेवी वर्मा",         topics:["गद्य — संस्मरण","स्त्री-शिक्षा","सांप्रदायिक सद्भाव"] },
      { no:"K8",  title:"एक कुत्ता और एक मैना — हजारीप्रसाद द्विवेदी",topics:["गद्य — निबन्ध","पशु-पक्षी से सीख"] },
      { no:"K9",  title:"कबीर — साखियाँ एवं सबद",                  topics:["पद्य — भक्ति काव्य","ईश्वर, गुरु, माया"] },
      { no:"K10", title:"ललद्यद",                                    topics:["पद्य — वाख","कश्मीरी भक्ति काव्य"] },
      { no:"K11", title:"रसखान — सवैये",                             topics:["पद्य — कृष्ण भक्ति","ब्रज की छवि"] },
      { no:"K12", title:"माखनलाल चतुर्वेदी — कैदी और कोकिला",      topics:["पद्य — राष्ट्रीय भावना","स्वतंत्रता संघर्ष"] },
      { no:"K13", title:"सुमित्रानंदन पंत — ग्राम श्री",            topics:["पद्य — प्रकृति काव्य","छायावाद"] },
      { no:"K14", title:"केदारनाथ अग्रवाल — चंद्र गहना से लौटती बेर",topics:["पद्य — प्रकृति","ग्रामीण चित्रण"] },
      { no:"K15", title:"सर्वेश्वर दयाल सक्सेना — मेघ आए",         topics:["पद्य — बादल का मानवीकरण"] },
      { no:"K16", title:"चंद्रकांत देवताले — यमराज की दिशा",        topics:["पद्य — दिशाओं का प्रतीक","माँ"] },
      { no:"K17", title:"निराला — एक फूल की चाह",                   topics:["पद्य — सामाजिक समानता","छुआछूत"] },
      { no:"Kr1", title:"इस जल प्रलय में — फणीश्वरनाथ रेणु",       topics:["कृतिका — कहानी","बाढ़ का जीवन पर असर"] },
      { no:"Kr2", title:"मेरे संग की औरतें — मृदुला गर्ग",          topics:["कृतिका — संस्मरण","स्त्री-शक्ति"] },
      { no:"Kr3", title:"रीढ़ की हड्डी — जगदीशचंद्र माथुर",         topics:["कृतिका — एकांकी","स्त्री-शिक्षा","दहेज"] },
      { no:"Kr4", title:"माटी वाली — विद्यासागर नौटियाल",            topics:["कृतिका — कहानी","पहाड़ी जीवन","विस्थापन"] },
      { no:"Kr5", title:"किस तरह आखिरकार मैं हिंदी में आया",        topics:["कृतिका — आत्मकथ्य","शमशेर बहादुर सिंह"] },
    ],
  },
  {
    id: "english",
    label: "English",
    icon: "📖",
    color: T.pink,
    tagline: "NCERT Class 9 — Beehive & Moments",
    chapters: [
      { no:"B1",  title:"The Fun They Had",                   topics:["Prose — Beehive","Isaac Asimov","Future of schooling","Comprehension & vocabulary"] },
      { no:"B2",  title:"The Sound of Music",                  topics:["Prose — Beehive","Evelyn Glennie (deaf musician)","Bismillah Khan","Perseverance"] },
      { no:"B3",  title:"The Little Girl",                    topics:["Prose — Beehive","Katherine Mansfield","Father-daughter relationship"] },
      { no:"B4",  title:"A Truly Beautiful Mind",             topics:["Prose — Beehive","Albert Einstein biography","Theory of Relativity"] },
      { no:"B5",  title:"The Snake and the Mirror",           topics:["Prose — Beehive","Dr Vaikom Muhammad Basheer","Humour, irony"] },
      { no:"B6",  title:"My Childhood",                       topics:["Prose — Beehive","A.P.J. Abdul Kalam","Autobiography, communal harmony"] },
      { no:"B7",  title:"Packing",                            topics:["Prose — Beehive","Jerome K. Jerome","Humorous writing"] },
      { no:"B8",  title:"Reach for the Top",                  topics:["Prose — Beehive","Santosh Yadav & Maria Sharapova","Determination"] },
      { no:"B9",  title:"The Bond of Love",                   topics:["Prose — Beehive","Kenneth Anderson","Man-animal bond"] },
      { no:"B10", title:"Kathmandu",                          topics:["Prose — Beehive","Vikram Seth","Travel writing, contrast"] },
      { no:"B11", title:"If I Were You",                      topics:["Prose — Beehive","Douglas James","Drama, thriller, humour"] },
      { no:"P1",  title:"The Road Not Taken",                 topics:["Poem — Robert Frost","Choice and consequences","Symbolism"] },
      { no:"P2",  title:"Wind",                               topics:["Poem — Subramania Bharati","Strength, perseverance","Metaphor"] },
      { no:"P3",  title:"Rain on the Roof",                   topics:["Poem — Coates Kinney","Memory, nostalgia","Imagery"] },
      { no:"P4",  title:"The Lake Isle of Innisfree",         topics:["Poem — W. B. Yeats","Peace, nature longing"] },
      { no:"P5",  title:"A Legend of the Northland",          topics:["Poem — Phoebe Cary","Ballad form","Moral story"] },
      { no:"P6",  title:"No Men Are Foreign",                 topics:["Poem — James Kirkup","Universal brotherhood","Anti-war"] },
      { no:"P7",  title:"The Duck and the Kangaroo",          topics:["Poem — Edward Lear","Nonsense verse","Friendship"] },
      { no:"P8",  title:"On Killing a Tree",                  topics:["Poem — Gieve Patel","Environmental message","Free verse"] },
      { no:"P9",  title:"The Snake Trying",                   topics:["Poem — W. W. E. Ross","Empathy for animals"] },
      { no:"P10", title:"A Slumber Did My Spirit Seal",       topics:["Poem — William Wordsworth","Death, nature","Romantic poetry"] },
      { no:"M1",  title:"The Lost Child",                     topics:["Moments — Mulk Raj Anand","Fair, child psychology"] },
      { no:"M2",  title:"The Adventures of Toto",             topics:["Moments — Ruskin Bond","Humour, mischief"] },
      { no:"M3",  title:"Iswaran the Storyteller",            topics:["Moments — R.K. Laxman","Storytelling, imagination"] },
      { no:"M4",  title:"In the Kingdom of Fools",            topics:["Moments — Folklore","Justice, consequence"] },
      { no:"M5",  title:"The Happy Prince",                   topics:["Moments — Oscar Wilde","Generosity, sacrifice"] },
      { no:"M6",  title:"Weathering the Storm in Ersama",     topics:["Moments — Harsh Mander","Cyclone survival, community"] },
      { no:"M7",  title:"The Last Leaf",                      topics:["Moments — O. Henry","Hope, art, sacrifice"] },
      { no:"M8",  title:"A House is Not a Home",              topics:["Moments — Zan Gaudioso","Loss, belonging"] },
      { no:"M9",  title:"The Accidental Tourist",             topics:["Moments — Bill Bryson","Humour, travel writing"] },
      { no:"M10", title:"The Beggar",                         topics:["Moments — Anton Chekhov","Compassion, reform, dignity"] },
    ],
  },
];

const SUB_TAG_COLORS = {
  H: { bg:"rgba(248,113,113,0.1)", color:"#F87171", label:"History" },
  G: { bg:"rgba(52,211,153,0.1)",  color:"#34D399", label:"Geography" },
  C: { bg:"rgba(56,189,248,0.1)",  color:"#38BDF8", label:"Civics" },
  E: { bg:"rgba(251,146,60,0.1)",  color:"#FB923C", label:"Economics" },
  K: { bg:"rgba(167,139,250,0.1)", color:"#A78BFA", label:"Kshitij" },
  Kr:{ bg:"rgba(244,114,182,0.1)", color:"#F472B6", label:"Kritika" },
  B: { bg:"rgba(56,189,248,0.1)",  color:"#38BDF8", label:"Beehive" },
  P: { bg:"rgba(52,211,153,0.1)",  color:"#34D399", label:"Poem" },
  M: { bg:"rgba(251,146,60,0.1)",  color:"#FB923C", label:"Moments" },
};

function getTag(no) {
  const s = String(no);
  if (s.startsWith("Kr")) return SUB_TAG_COLORS.Kr;
  for (const key of Object.keys(SUB_TAG_COLORS)) {
    if (s.startsWith(key)) return SUB_TAG_COLORS[key];
  }
  return null;
}

function ChapterCard({ ch, accent }) {
  const [open, setOpen] = useState(false);
  const tag = getTag(ch.no);
  return (
    <div style={{border:`1px solid ${T.border}`,borderRadius:10,overflow:"hidden",marginBottom:9}}>
      <button onClick={()=>setOpen(!open)}
        style={{width:"100%",display:"flex",alignItems:"center",gap:14,textAlign:"left",
          padding:"13px 16px",background:T.card,border:"none",cursor:"pointer"}}>
        <span style={{flexShrink:0,width:32,height:32,borderRadius:7,background:`rgba(255,255,255,0.05)`,
          border:`1px solid ${T.border}`,color:accent,fontFamily:"monospace",fontSize:11,fontWeight:700,
          display:"flex",alignItems:"center",justifyContent:"center",letterSpacing:-.5}}>
          {ch.no}
        </span>
        <span style={{flex:1,color:T.textPri,fontSize:14.5,fontWeight:500,lineHeight:1.4}}>{ch.title}</span>
        {tag && (
          <span style={{flexShrink:0,fontSize:10,fontWeight:700,letterSpacing:.6,textTransform:"uppercase",
            background:tag.bg,color:tag.color,borderRadius:4,padding:"2px 7px",display:"none"}}
            className="tag-label">
            {tag.label}
          </span>
        )}
        <span style={{fontSize:14,color:T.textMute,flexShrink:0}}>
          {open ? "▾" : "▸"}
        </span>
      </button>
      {open && (
        <div style={{padding:"10px 16px 14px 62px",background:T.surface}}>
          <div style={{display:"flex",flexWrap:"wrap",gap:7}}>
            {ch.topics.map(t=>(
              <span key={t} style={{fontSize:12.5,color:T.textSec,background:T.card,
                border:`1px solid ${T.border}`,borderRadius:20,padding:"3px 10px",lineHeight:1.5}}>
                {t}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default function Class9({ subject: initialSubject }) {
  const [activeSub, setActiveSub] = useState(initialSubject || "maths");
  const mainRef = useRef(null);

  const subject = SUBJECTS.find(s => s.id === activeSub);

  const switchSub = (id) => {
    setActiveSub(id);
    if (mainRef.current) mainRef.current.scrollTop = 0;
  };

  return (
    <div style={{display:"flex",height:"calc(100vh - 70px)",background:T.bg,fontFamily:"'Inter',sans-serif"}}>

      {/* ── Sidebar ── */}
      <div style={{width:220,flexShrink:0,background:T.surface,borderRight:`1px solid ${T.border}`,
        overflowY:"auto",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"18px 16px 12px",borderBottom:`1px solid ${T.border}`}}>
          <div style={{fontSize:10,letterSpacing:1.2,textTransform:"uppercase",color:"#A78BFA",fontWeight:700,marginBottom:5}}>
            Academics
          </div>
          <div style={{fontSize:15,fontWeight:800,color:T.textPri}}>Class 9</div>
          <div style={{fontSize:12,color:T.textMute,marginTop:3}}>NCERT — All Subjects</div>
        </div>
        <nav style={{padding:"10px 8px",flex:1}}>
          {SUBJECTS.map(s => (
            <button key={s.id} onClick={()=>switchSub(s.id)}
              style={{display:"flex",alignItems:"center",gap:10,width:"100%",textAlign:"left",
                padding:"10px 10px",borderRadius:8,border:"none",cursor:"pointer",marginBottom:4,
                background: activeSub===s.id ? `rgba(255,255,255,0.06)` : "transparent",
                borderLeft: activeSub===s.id ? `3px solid ${s.color}` : "3px solid transparent",
                color: activeSub===s.id ? T.textPri : T.textSec,
                fontSize:14,fontWeight: activeSub===s.id ? 700 : 400,
                transition:"all 0.15s"}}>
              <span style={{fontSize:17}}>{s.icon}</span>
              {s.label}
            </button>
          ))}
        </nav>
        <div style={{padding:"12px 16px",borderTop:`1px solid ${T.border}`,fontSize:11,color:T.textMute,lineHeight:1.6}}>
          Click any chapter to see key topics. Content will grow chapter by chapter.
        </div>
      </div>

      {/* ── Main ── */}
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>

        {/* Subject banner */}
        <div style={{flexShrink:0,padding:"20px 36px 18px",
          background:`linear-gradient(135deg, ${T.surface} 0%, ${T.card} 100%)`,
          borderBottom:`1px solid ${T.border}`}}>
          <div style={{display:"flex",alignItems:"center",gap:14}}>
            <div style={{fontSize:36,lineHeight:1}}>{subject.icon}</div>
            <div>
              <div style={{fontSize:11,letterSpacing:1,textTransform:"uppercase",color:subject.color,
                fontWeight:700,marginBottom:4}}>Class 9 · NCERT</div>
              <h2 style={{fontSize:22,fontWeight:800,color:T.textPri,margin:0}}>{subject.label}</h2>
              <div style={{fontSize:13,color:T.textMute,marginTop:3}}>{subject.tagline}</div>
            </div>
            <div style={{marginLeft:"auto",textAlign:"right"}}>
              <div style={{fontSize:28,fontWeight:800,color:subject.color,fontFamily:"monospace"}}>
                {subject.chapters.length}
              </div>
              <div style={{fontSize:11,color:T.textMute,letterSpacing:.5}}>chapters</div>
            </div>
          </div>
        </div>

        {/* Scrollable content */}
        <div ref={mainRef} style={{flex:1,overflowY:"auto",padding:"28px 36px"}}>

          {/* SST: show split tags */}
          {subject.id === "sst" && (
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:20}}>
              {[
                {key:"H",label:"History",color:"#F87171"},
                {key:"G",label:"Geography",color:"#34D399"},
                {key:"C",label:"Civics",color:"#38BDF8"},
                {key:"E",label:"Economics",color:"#FB923C"},
              ].map(t=>(
                <span key={t.key} style={{fontSize:12,fontWeight:600,letterSpacing:.5,textTransform:"uppercase",
                  color:t.color,background:`rgba(255,255,255,0.05)`,border:`1px solid ${t.color}33`,
                  borderRadius:5,padding:"3px 10px"}}>
                  {t.label}
                </span>
              ))}
            </div>
          )}

          {/* English: show split tags */}
          {subject.id === "english" && (
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:20}}>
              {[
                {label:"Beehive Prose",color:"#38BDF8"},
                {label:"Poems",color:"#34D399"},
                {label:"Moments",color:"#FB923C"},
              ].map(t=>(
                <span key={t.label} style={{fontSize:12,fontWeight:600,letterSpacing:.5,textTransform:"uppercase",
                  color:t.color,background:`rgba(255,255,255,0.05)`,border:`1px solid ${t.color}33`,
                  borderRadius:5,padding:"3px 10px"}}>
                  {t.label}
                </span>
              ))}
            </div>
          )}

          {/* Hindi: show split tags */}
          {subject.id === "hindi" && (
            <div style={{display:"flex",flexWrap:"wrap",gap:8,marginBottom:20}}>
              {[
                {label:"Kshitij (क्षितिज)",color:"#A78BFA"},
                {label:"Kritika (कृतिका)",color:"#F472B6"},
              ].map(t=>(
                <span key={t.label} style={{fontSize:12,fontWeight:600,letterSpacing:.5,textTransform:"uppercase",
                  color:t.color,background:`rgba(255,255,255,0.05)`,border:`1px solid ${t.color}33`,
                  borderRadius:5,padding:"3px 10px"}}>
                  {t.label}
                </span>
              ))}
            </div>
          )}

          {subject.chapters.map(ch => (
            <ChapterCard key={ch.no} ch={ch} accent={subject.color} />
          ))}

          {/* Footer tip */}
          <div style={{marginTop:28,background:T.card,border:`1px solid ${T.border}`,
            borderLeft:`3px solid ${subject.color}`,borderRadius:10,padding:"14px 18px"}}>
            <div style={{fontSize:12,letterSpacing:.8,textTransform:"uppercase",color:subject.color,
              fontWeight:700,marginBottom:8}}>Study tip</div>
            <div style={{fontSize:14,color:T.textSec,lineHeight:1.7}}>
              {subject.id==="maths" && "Practice each theorem with examples before moving to the next. NCERT exercises are sufficient for exams — attempt every question."}
              {subject.id==="science" && "Diagrams are worth marks. Draw and label — cell structure, atom models, motion graphs, ear diagram. Revise definitions precisely."}
              {subject.id==="sst" && "History and Economics need timelines and cause-effect notes. For Geography, draw maps. For Civics, focus on key terms and examples."}
              {subject.id==="hindi" && "For every prose, note: लेखक, विधा, मुख्य भाव और कठिन शब्द। कविता के लिए भाव-सौंदर्य और काव्य-सौंदर्य दोनों समझें।"}
              {subject.id==="english" && "For each lesson note the author, genre, theme, and 5 key vocabulary words. For poems, identify the figure of speech used in every stanza."}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
